import { isEmpty } from 'remeda'
import type { Image, Product } from '@velasca/types'

const EDITORIAL_IMAGE_PREFIX = '02_'

interface CompleteTheLookEditorialImageArgs {
  product: {
    editorialImage?: string | null
    medias?: Product['medias']
    images?: Image[]
  }
  defaultImage?: string
}

export const getCompleteTheLookEditorialImage = ({
  product,
  defaultImage,
}: CompleteTheLookEditorialImageArgs): string | null => {
  if (product.editorialImage) {
    return product.editorialImage
  }

  if (product.medias && !isEmpty(product.medias)) {
    const editorialImage = product.medias
      .filter((media) => media.type === 'image')
      .find((media) => {
        const filename = media.src.match(/\/([^/]+)$/)?.[1] || media.src

        return filename.startsWith(EDITORIAL_IMAGE_PREFIX)
      })

    if (editorialImage) {
      return editorialImage.src
    }
  }

  if (product.images && !isEmpty(product.images)) {
    const editorialImage = product.images.find((media) => {
      const filename = media.src.match(/\/([^/]+)$/)?.[1] || media.src

      return filename.startsWith(EDITORIAL_IMAGE_PREFIX)
    })

    if (editorialImage) {
      return editorialImage.src
    }
  }

  return defaultImage || null
}
